module.exports = __webpack_public_path__ + "img/yjaq-bg0510.7d37c57a.jpg";